import React, { useEffect, useState } from 'react'
import { navigate } from 'raviger'

import { useStore } from 'laco-react'
import ClubStore, { setSelection, getSelectedClub } from 'Store/clubs'

import { Col, Row } from 'Components/shared/Container'

import CloneClient from 'Components/CloneClient'

import { Button } from 'Components/shared/Button'
import styled from '@emotion/styled'
import { Flex } from 'lese'
import { createModal } from 'Components/Modal'

import { toast } from 'react-toastify'

import Select from 'react-select'

const SelectContainer = styled(Flex)`
  grid-column: 1;
  padding: 16px;
  width: 400px;
`

const ClientSelectMenu = styled(Select)`
  width: 400px;
`

export default ({
  setSelected,
  setSelectedClub,
  setPreviewImages,
  setMaster,
  setCustomLinks,
  club
}) => {
  const { clubs } = useStore(ClubStore)
  const [options, setOptions] = useState(['Loading'])

  useEffect(async () => {
    const map = clubs.map(c => {
      return { value: decodeURI(c.clubname), label: decodeURI(c.clubname) }
    })
    setOptions(map)
  }, [clubs, club])

  const onClubChangeClick = async clubName => {
    let foundClub = clubs.filter(c => {
      return decodeURI(c.clubname) === clubName
    })

    if (foundClub.length === 0) {
      return toast.error('Club was not found.')
    }

    // Fancy array deconstruction, foundClub[0]
    ;[foundClub] = foundClub

    setSelection({ clubId: foundClub.id }).then(() => {
      setSelected(true)
      getSelectedClub().then(c => {
        setSelectedClub(c)
        setMaster(c)
        setPreviewImages({})
      })
    })
  }

  return (
    <>
      <Row>
        <Col xs={8}>
          <SelectContainer>
            <ClientSelectMenu
              options={options}
              value={
                club.clubName
                  ? { value: decodeURI(club.clubName), label: decodeURI(club.clubName) }
                  : { value: 'Select A Client', label: 'Select A Client' }
              }
              onChange={obj => {
                const { value } = obj
                onClubChangeClick(value)
              }}
            />
          </SelectContainer>
        </Col>
        <Col xs={4}>
          <Row>
            <Button
              color="#17a2b8"
              style={{ marginRight: '10px' }}
              onClick={() => {
                navigate('/new')
              }}
            >
              Add New Client
            </Button>
            <Button
              onClick={() => {
                createModal(
                  <CloneClient
                    options={options}
                    clubs={clubs}
                    setSelectedClub={setSelectedClub}
                    setSelected={setSelected}
                    setMaster={setMaster}
                    setCustomLinks={setCustomLinks}
                  />
                )
              }}
            >
              Clone New Client
            </Button>
          </Row>
        </Col>
      </Row>
    </>
  )
}
